import React, { useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useStudent } from "../context/StudentContext";
import { buildStudentTabPath } from "../utils/studentTabRouting";

/**
 * Legacy /usuario/curso/:id URLs redirect to campus with the active course and tab.
 */
function CursoUsuarioRedirect() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { courses, setActiveCourse, loading, activeCourseTabHints } = useStudent();

  useEffect(() => {
    if (loading) return;

    const course = courses.find((c) => String(c._id) === String(id));
    if (course) {
      setActiveCourse(course);
    }

    const pestana = location.state?.pestanaInicial;
    const target =
      typeof pestana === "string" && pestana.trim() !== ""
        ? buildStudentTabPath(pestana.trim(), activeCourseTabHints)
        : "/usuario/campus";

    navigate(target, { replace: true });
  }, [id, loading, courses, location.state, navigate, setActiveCourse, activeCourseTabHints]);

  return (
    <div className="cds-campus-loading" style={{ padding: "48px", textAlign: "center" }}>
      <p>Redirigiendo al campus…</p>
    </div>
  );
}

export default CursoUsuarioRedirect;
